<app-component-header></app-component-header>

<div class="component-block">
    <div class="warning-message flex-display">
        <div>
            Lỗi Mã QRCode không tồn tại !
            <br/>
            Vui lòng nhập QRCode chính xác
        </div>
    </div>
    <div class="row my-3">
        <div class="div-center">
            <button nz-button nzType="primary" nzSize="large" nzShape="round" class="btn-sacom-o" (click)="goToDefaultPage()">
                Trở về Trang chủ
            </button>
        </div>
    </div>
</div>

<app-component-footer></app-component-footer>